import { InvoiceSchedule, OrderItemForScheduling } from "../types";
import { ScheduleForm } from "./ScheduleForm";

type InvoiceScheduleDialogProps = {
    isOpen: boolean;
    orderId: number;
    treatmentId: number;
    onClose: () => void;
    schedule?: InvoiceSchedule;
    orderTotal: number;
    pendingScheduledTotal: number;
    invoicedTotal: number | null;
    orderItems: Array<OrderItemForScheduling>;
};

export const InvoiceScheduleDialog = ({
    isOpen,
    orderId,
    treatmentId,
    onClose,
    schedule,
    orderTotal,
    pendingScheduledTotal,
    invoicedTotal,
    orderItems,
}: InvoiceScheduleDialogProps) => {
    return (
        <ScheduleForm
            isOpen={isOpen}
            orderId={orderId}
            treatmentId={treatmentId}
            schedule={schedule}
            onClose={onClose}
            orderTotal={orderTotal}
            pendingScheduledTotal={pendingScheduledTotal}
            invoicedTotal={invoicedTotal}
            orderItems={orderItems}
        />
    );
};
